var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: _vm.cardStyle }, [
    _vm.hasHeader
      ? _c("header", { style: _vm.headerStyle }, [_vm._t("header")], 2)
      : _vm._e(),
    _vm._v(" "),
    _c("main", { style: _vm.mainStyle }, [_vm._t("default")], 2),
    _vm._v(" "),
    _vm.hasfooter
      ? _c("footer", { style: _vm.footerStyle }, [_vm._t("footer")], 2)
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9e31bb88", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e31bb88","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/Card.vue
// module id = null
// module chunks = 